export default "__VITE_ASSET__DC8GJ24R__"